"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _Title = _interopRequireDefault(require("../../Title"));

var _utils = require("../../utils");

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var BuyNowComponent = function BuyNowComponent(props) {
  var _a = props || {},
      configuration = _a.configuration,
      flexTitle = _a.flexTitle,
      style = _a.style;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'whitepaper-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '0 -24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'dropdown-cards-container'
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        description = _a.description,
        thumbnail = _a.thumbnail,
        href = _a.href,
        extendProps = _a.extendProps;

    var _b = (0, _utils.fomateFileData)(thumbnail),
        thumbnailUrl = _b.url,
        _c = _b.alt,
        alt = _c === void 0 ? '' : _c;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'white-paper-default-container-list',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: 'white-paper-default-container'
    }, extendProps || {}, {
      onClick: function onClick() {
        return window.location.href = href;
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'white-paper-default-container__left'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: thumbnailUrl || 'https://main.qcloudimg.com/qcintl-cms/154/1624602949190/b17b214cba359aaf2baa41843eb6c205.png',
      alt: alt
    })), /*#__PURE__*/_react["default"].createElement("section", {
      className: 'white-paper-default-container__right'
    }, /*#__PURE__*/_react["default"].createElement("h2", null, title || 'Tencent Cloud Fintech Solutions'), /*#__PURE__*/_react["default"].createElement("article", {
      dangerouslySetInnerHTML: {
        __html: description || 'article'
      }
    }))));
  })));
};

BuyNowComponent.displayName = 'TCIBuyNowComponent';
var _default = BuyNowComponent;
exports["default"] = _default;